import React, { useContext } from 'react';
import EDIcon from '../../../../../../BaseComponents/Icon/EDIcon';
import EDTextLines from '../../../../../../BaseComponents/TextLines/EDTextLines';
import EDTooltip from '../../../../../../BaseComponents/Tooltip/EDTooltip';
import { getDate } from '../../../../../../Utils/dateUtils';
import { ValueType } from '../../../../../../Utils/Formatters/FormatterTypes';
import BusinessDetailContext from '../../../../_Common/Components/BusinessDetailContext/BusinessDetailContext';
import { DisplayCompType } from '../../../../_Common/Const/BusinessConfigs';

interface IProps {
  value: ValueType;
  displayValue: string;
}

const getTimerIcon = (paminnelseStatus: string, forfalloDatum: Date) => {
  const todaysDate = getDate();
  const isExpired = todaysDate > forfalloDatum;
  if (
    paminnelseStatus === 'PAMINN_BESLUTSATTESTANT' ||
    paminnelseStatus === 'PAMINN_MOTTAGNINGSATTESTANT' ||
    paminnelseStatus === 'PAMINN_UTREDNING'
  ) {
    return (
      <EDTooltip title={isExpired ? 'Förfallen' : 'Förfaller snart'}>
        <span>
          <EDIcon
            color={isExpired ? 'error' : undefined}
            iconType="timer_outlined"
            size="default"
          ></EDIcon>
        </span>
      </EDTooltip>
    );
  }
  return '';
};

const FakturaDelTimerIkon: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const businessDetailContext = useContext(BusinessDetailContext);
  const paminnelseStatus = businessDetailContext.data?.PaminnelseStatus;

  const forfalloDatum = getDate(
    new Date(businessDetailContext.data?._Associations?.Faktura?.FORFALLO_DATUM)
  );

  return (
    <>
      <EDTextLines lines={props.displayValue.split('\n')} />
      <span> </span>
      {getTimerIcon(paminnelseStatus, forfalloDatum)}
    </>
  );
};

const displayFakturaDelTimerIkon: DisplayCompType = FakturaDelTimerIkon;

export default displayFakturaDelTimerIkon;
